// @flow

import type { Gender } from './gender'
import { GENDER_UNKNOWN } from './gender'

export const CUSTOMER_TYPE_COMMERCIAL = 'commercial'

export type ContactPersonDetails = {
  firstName?: ?string,
  surnamePrefix?: ?string,
  surname?: ?string,
  gender?: Gender,
  emailAddress?: ?string,
  department?: ?string,
  customerType: string
}

const buildContactPersonDetails = (): ContactPersonDetails => {
  return {
    firstName: '',
    surnamePrefix: '',
    surname: '',
    gender: GENDER_UNKNOWN,
    emailAddress: '',
    department: '',
    customerType: CUSTOMER_TYPE_COMMERCIAL
  }
}

export {
  buildContactPersonDetails
}



// WEBPACK FOOTER //
// ./src/types/contact-details.js